
const groupAllSelectors = document.querySelectorAll<HTMLInputElement>('[data-permission="all"]');
groupAllSelectors.forEach((element) => {
  element.addEventListener('change', function (this: HTMLInputElement) {
    const id = this.id;
    const isChecked = this.checked;
    const others = document.querySelectorAll<HTMLInputElement>(`[data-permission="${id}"]`);
    others.forEach((item) => {
      item.checked = isChecked;
    });
  });
});

const singleSelectors = document.querySelectorAll<HTMLInputElement>('[data-permission]:not([data-permission="all"])');
singleSelectors.forEach((element) => {
  element.addEventListener('change', function (this: HTMLInputElement) {
    const id = this.dataset.permission;
    if (!id) return;

    const groupSelectors = document.querySelectorAll<HTMLInputElement>(`[data-permission="${id}"]`);
    let allChecked = true;
    groupSelectors.forEach((item) => {
      allChecked = allChecked && item.checked;
    });

    const groupSelector = document.querySelector<HTMLInputElement>(`#${id}`);
    if (groupSelector) {
      groupSelector.checked = allChecked;
    }
  });
});

const roleSelect = document.querySelector<HTMLSelectElement>('[data-roles]');
if (roleSelect) {
  roleSelect.addEventListener('change', function (this: HTMLSelectElement) {
    // Reset all checkboxes
    document.querySelectorAll<HTMLInputElement>('[data-permission]')
      .forEach(selector => { selector.checked = false; });

    const allOptions = this.querySelectorAll<HTMLOptionElement>('option:checked');
    allOptions.forEach(option => {
      if (option.value) {
        const values = option.value.split(',');
        values.forEach(value => {
          const item = document.querySelector<HTMLInputElement>(`#${value}`);
          if (!item) return;
          item.checked = option.selected;
          item.dispatchEvent(new Event('change'));
        });
      }
    });
  });
}
